/**
 * @module: 简历模块store
 * @author: xiongsha
 * @date: 2019-12-31 16:38:09
 */

import { observable, action, flow } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { Toast } from 'antd-mobile';
import { IMineResume, IAttachment } from '@src/entity/resident/resume';
import { IEduction, IEmployments, IPortfolios, IResumeDetail } from '@src/entity/zhaopin/resume';
import { ITrain } from '@src/entity/resident/resume';
import { withRole } from '@src/utils/residentNew';
import resident from '@src/store/resident/index';
import Axios from 'axios';
class Resume {
  // 编辑擅长技能
  @observable editSkillDrawer: boolean = false;
  // 编辑个人介绍
  @observable personIntroduceDrawer: boolean = false;
  // 编辑工作内容
  @observable workContentDrawer: boolean = false;
  // 编辑工作业绩
  @observable workAchDrawer: boolean = false;
  // 添加项目描述
  @observable projectDescDrawer: boolean = false;
  // 添加项目业绩
  @observable projectAchDrawer: boolean = false;
  // 添加项目经历
  @observable projectLinkDrawer: boolean = false;
  // 培训地点
  @observable trainAdressDrawer: boolean = false;
  // 培训描述
  @observable trainDescDrawer: boolean = false;
  // 简历重命名
  @observable renResume: boolean = false;
  // 简历操作弹窗
  @observable editResume: boolean = false;
  //  我的简历
  @observable mineResume?: IMineResume;
  // 候选人简历信息
  @observable resumeDetail?: IMineResume;
  //  存储某条工作经历
  @observable workExperItem?: IEmployments;
  //  存储某条项目经历
  @observable projectExperItem?: IPortfolios;
  //  存储某条教育经历
  @observable eduExperItem?: IEduction;
  //  存储某条培训经历
  @observable trainExperItem?: ITrain;
  //存储简历附件
  @observable attachment?: IAttachment[];

  @observable attachmentFetching: string = 'init';
  /* 控制drawer显示隐藏 */
  @action.bound
  changeDrawer(name: string, val: boolean) {
    this[name] = val;
  }

  //  获取自己简历信息
  @action.bound
  getResume = async () => {
    const res: any = await ajax.getJson('/resident/api/resumes/mine', withRole({}, 2));
    if (res.error_code === 0) {
      this.mineResume = res.resume;
    } else {
      Toast.fail(res.message);
    }
    return res;
  };

  // 获取候选人简历信息
  @action.bound
  getResumeDetail = flow(function* (this: Resume, uuid: string) {
    try {
      const res: any = yield ajax.getJson(`/resident/api/resumes/${uuid}`, withRole({}));
      if (res.error_code === 0) {
        this.resumeDetail = res.resume;
      } else {
        Toast.fail(res.message, 1);
      }
    } catch (error) {
      Toast.fail('offer请求失败');
    }
  });

  // 修改简历信息
  @action.bound
  changeResume = flow(function* (this: Resume, data, cb) {
    try {
      const res: any = yield ajax.putJson('/resident/api/resumes/mine', withRole(data, 2));
      if (res.error_code === 0) {
        this.mineResume = {
          ...this.mineResume,
          ...res.resume
        };
        cb();
      } else {
        Toast.fail(res.message, 1);
      }
    } catch (error) {
      console.log(error);
    }
  });

  // 修改候选人简历信息
  @action.bound
  changeResumeDetail = flow(function* (this: Resume, uuid, data, cb) {
    try {
      const res: any = yield ajax.putJson(`/resident/api/company/resumes/${uuid}`, withRole(data, 2));
      if (res.error_code === 0) {
        this.resumeDetail = {
          ...this.resumeDetail,
          ...res.resume
        };
        cb();
      } else {
        Toast.fail(res.message, 1);
      }
    } catch (error) {
      console.log(error);
    }
  });

  // 获取简历用户所在城市
  @action.bound
  formatResumeArea(resume: IMineResume | IResumeDetail, name) {
    let res = '';
    res = resume[name] && resume[name].location_name;
    if ((res === '' || res === '未填写') && name === 'current_location_1') {
      res = resume.work_city && resume.work_city.location_name;
    }
    return res;
  }

  // 获取简历附件
  @action.bound
  getAttachment = flow(function* (this: Resume, resume_uuid) {
    this.attachmentFetching = 'pending';

    try {
      const res: any = yield ajax.getJson(
        `/resident/api/resumes/${resume_uuid}/attachments`,
        withRole(
          {
            atype: 'resume-file'
          },
          2
        )
      );
      if (res.error_code === 0) {
        this.attachment = res.resume_attachments;
      } else {
        Toast.fail(res.message, 1);
      }
      this.attachmentFetching = 'done';
    } catch (error) {
      console.log(error);
    }
  });

  // 更新attachment
  @action.bound
  setAttachment(val: IAttachment[]) {
    this.attachment = val;
  }

  @action.bound
  setResumeExperItem(name, item) {
    // 存储某条工作经历
    this[name] = item;
  }
}

export default Resume;
